import React from 'react'
import { Location, useParams } from 'react-router-dom'

import { SubmissionForm } from 'features/briefs/components/submission-form'

const Submission = ({
  location,
  children,
}: {
  location: Location
  children: React.ReactNode
}) => {
  const { briefId, recipientId } =
    useParams<{ briefId: string; recipientId: string }>()
  return (
    <>
      <SubmissionForm
        group={window.group_data}
        businessData={window.business_data}
        location={location}
        params={{ groupId: briefId!, groupName: recipientId! }}
      />
      {children}
    </>
  )
}

export default Submission
